import { useEffect, useState } from "react";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { getBoideToken, hasAgreedPolicy } from "@/lib/boide-api";
import { useBoideUser } from "@/hooks/use-boide-user";
import { PolicyAgreementDialog } from "@/components/policy-agreement-dialog";
import { FeatureLanding } from "@/components/feature-landing";

export const Route = createFileRoute("/_authenticated")({
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { user, ready } = useBoideUser();

  // Khách chưa đăng nhập KHÔNG còn bị đẩy về /login — thay vào đó render landing
  // SEO (FeatureLanding) để bot cào/index được các trang tính năng:
  // - SSR + first client paint (mounted=false): luôn là landing, vì server không
  //   đọc được localStorage → HTML bot nhận về là nội dung thật, khớp hydration.
  // - Sau khi mount: có token → vào app ngay (không đợi getMe, trang con tự lo
  //   loading); không token hoặc token hỏng (getMe fail đã tự logout → ready &&
  //   !user) → ở lại landing với CTA đăng nhập kèm returnTo.
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  // Còn token là vào app, kể cả khi `getMe` vừa lỗi tạm thời (BE quá tải): token hỏng
  // thật thì `useBoideUser` đã logout (xoá token) → rơi về landing.
  const showApp = mounted && (user !== null || Boolean(getBoideToken()));

  if (!showApp) return <FeatureLanding />;

  return (
    <>
      {ready && user && !hasAgreedPolicy(user.username) && (
        <PolicyAgreementDialog username={user.username} />
      )}
      <Outlet />
    </>
  );
}
